const profile = {
    name: 'Imię',
    avatar: 'Avatar',
    givenName: 'Imię własne',
    familyName: 'Nazwisko',
    middleName: 'Drugie imię',
    fullname: 'Pełne imię i nazwisko',
    nickname: 'Pseudonim',
    preferredUsername: 'Preferowana nazwa użytkownika',
    profile: 'Profil',
    website: 'Strona internetowa',
    gender: 'Płeć',
    birthdate: 'Data urodzenia',
    zoneinfo: 'Strefa czasowa',
    locale: 'Język/locale',
    address: {
        formatted: 'Adres',
        streetAddress: 'Ulica',
        locality: 'Miasto',
        region: 'Województwo/region',
        postalCode: 'Kod pocztowy',
        country: 'Kraj',
    },
    gender_options: {
        female: 'Kobieta',
        male: 'Mężczyzna',
        prefer_not_to_say: 'Wolę nie mówić',
    },
    checkbox_value: {
        checked: 'Tak',
        unchecked: 'Nie',
    },
    avatar_upload: {
        upload: 'Prześlij',
        remove: 'Usuń',
        uploading: 'Przesyłanie...',
        hint: 'Zalecany rozmiar 1:1, do {{limit}}.',
        error_file_type: 'Typ pliku musi być {{extensions}}.',
        error_file_size: 'Rozmiar pliku nie może przekraczać {{limit}}.',
        error_storage_not_configured: 'Nie udało się przesłać zdjęcia. Spróbuj ponownie później.',
        error_upload: 'Nie udało się przesłać zdjęcia. Spróbuj ponownie.',
        error_save: 'Nie udało się zapisać zdjęcia. Spróbuj ponownie.',
        crop_title: 'Przytnij zdjęcie',
        zoom: 'Powiększenie',
        error_crop: 'Nie udało się przyciąć obrazu. Spróbuj ponownie.',
    },
};
export default Object.freeze(profile);
